<template>
  <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-label="X">
    <path :fill="fill" d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.657l-5.214-6.817-5.967 6.817H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
</template>

<script>
export default {
  name: "XIcon",
  props: {
    fill: {
      required: false,
      default: '#9EADC1'
    }
  },
}
</script>
